import { SWRConfig } from 'swr'
import { useState, FC } from 'react'
import { MaintenanceBlock } from './MaintenanceBlock'
import { useStoreConfig } from '@config/hooks/useStoreConfig'

const MAINTENANCE_CHECK_TIMER = 1000

export type MaintenanceProps = {
    isMaintenanceEnabled: boolean
}

export const Maintenance: FC<MaintenanceProps> = ({
    isMaintenanceEnabled = false,
    children
}) => {
    const [isMaintenanceMode, setIsMaintenanceMode] = useState(false)
    const config = useStoreConfig()
    let isHealthCheckInProgress = false

    const checkIsMaintenanceModeEnabled = async () => {
        try {
            if (!isHealthCheckInProgress) {
                isHealthCheckInProgress = true // set the progress flag
                const timeStamp = Date.now() //bypass the cache with timestamp
                const response = await fetch(
                    `${config.base.url.mediaBackend?.baseMediaUrl}healthy.jpg?ts=${timeStamp}`,
                    {
                        method: 'GET',
                        cache: 'no-cache'
                    }
                )
                //if no healthy flag missing then set maintenance mode ON
                if (response.ok) {
                    // If the site is alive, then error was not caused by maintenance mode
                    // so don't make another maintenance check for next second.
                    setTimeout(
                        () => (isHealthCheckInProgress = false),
                        MAINTENANCE_CHECK_TIMER
                    )
                } else {
                    //once the maintenance mode is ON then no recurring request triggered
                    setIsMaintenanceMode(true)
                }
            }
        } catch (e) {
            console.warn('Request error found')
        }
    }

    /**
     * Only considering the error case from SWR hook as we will have at-least one request
     * with SWR in each page. so maintenance page check would happen if any query fails
     * If needed consider graphqlFetch Error the create
     * context to track its global error for fetch
     * @param error
     * @returns void
     */
    const errorHandler = async (error: Error) => {
        //can consider this method to add more handler with {key} and {config} values
        if (error) await checkIsMaintenanceModeEnabled()
    }

    //if maintenance is not enabled then don't trigger the checking
    if (!isMaintenanceEnabled) return <>{children}</>

    return (
        <SWRConfig value={{ onError: errorHandler }}>
            {isMaintenanceMode ? <MaintenanceBlock /> : children}
        </SWRConfig>
    )
}
